import CheckoutService from "../../../../common/services/checkout/CheckoutService";
import CustomerService from "../../../../common/services/customer/CustomerService";
import { GET_CUSTOMER_ORDERS, GET_CUSTOMER_ORDER_KITS, SWITCH_ORDER_FORM } from "./actions";

export default {
    /**
     * TODO change the state variable names and getters  to camelCase
     */
    state: {
        orders: [],
        showOrderForm: false,
        orderStatuses:[],
    },
    getters: {
        customerOrders: (state) => {
            return state.orders
        },
        orderStatuses: (state) => {
            return state.orderStatuses
        },
        showOrderForm: (state) => {
            return state.showOrderForm
        }
    },
    mutations: {
        [SWITCH_ORDER_FORM]: (state) => {
            state.showOrderForm = !state.showOrderForm;
        },
        [GET_CUSTOMER_ORDERS]: (state, data) => {
            state.orders = data;
        },
        [GET_CUSTOMER_ORDER_KITS]: (state, {kits, orderId}) => {
            state.orders.forEach(element => {
                if(element.id == orderId) {
                    element.kitsList = kits;
                }
            });
        },
        orderStatuses: (state, data) => {
            state.orderStatuses = data;
        }
    },
    actions: {
        [GET_CUSTOMER_ORDERS]: async (context) => {
            var customerService = new CustomerService();
            var results = await customerService.getCustomerOrders(context.getters.customer.id);
            
            context.commit(GET_CUSTOMER_ORDERS, results.data.data);
        },

        [GET_CUSTOMER_ORDER_KITS]: async (context, id) => {
            var checkoutService = new CheckoutService();
            var results = await checkoutService.getKits(id, {customer_id: context.getters.customer.id});
            
            var data = {orderId: id, kits: results.data.data};
            context.commit(GET_CUSTOMER_ORDER_KITS, data);

            return results;

        },
        orderStatuses: async (context, data) => {
            var checkoutService = new CheckoutService();
            var results = await checkoutService.orderStatuses();
        
            context.commit('orderStatuses', results.data.data);

            return results;
        }
    },
};